import { type FC, type ReactNode } from 'react'
import { Button } from '../../../../../components/Button/Button'
import { StatusBanner, type StatusBannerTone } from '../../../../Scheduling/shared/StatusBanner'

interface SectionHeaderProps {
  title: string
  subtitle: string
  action?: ReactNode
}

export const SectionHeader: FC<SectionHeaderProps> = ({ title, subtitle, action }) => (
  <div className='d-flex align-items-start justify-content-between gap-3'>
    <div className='d-flex flex-column'>
      <span className='bold paragraph-large'>{title}</span>
      <span className='paragraph-small zocks-text-gray-600'>{subtitle}</span>
    </div>
    {action}
  </div>
)

export interface HostsNotice {
  tone: StatusBannerTone
  text: string
}

interface HostsSectionProps {
  title: string
  subtitle: string
  action?: ReactNode
  notice?: HostsNotice | null
  children: ReactNode
}

export const HostsSection: FC<HostsSectionProps> = ({ title, subtitle, action, notice, children }) => (
  <div className='d-flex flex-column gap-3'>
    <SectionHeader title={title} subtitle={subtitle} action={action} />
    {notice ? <StatusBanner tone={notice.tone}>{notice.text}</StatusBanner> : null}
    {children}
  </div>
)

export const HostsList: FC<{ children: ReactNode }> = ({ children }) => (
  <div className='d-flex flex-column border rounded-3 zocks-border-color-gray-300 zocks-bg-color-white'>{children}</div>
)

interface EmptyHostsBoxProps {
  text: string
  actionLabel?: string
  actionIcon?: string
  onAction?: () => void
}

export const EmptyHostsBox: FC<EmptyHostsBoxProps> = ({ text, actionLabel, actionIcon, onAction }) => (
  <div className='d-flex flex-column align-items-center justify-content-center gap-3 py-5 rounded-2 zocks-bg-color-gray-100 paragraph-small zocks-text-gray-900 text-center'>
    <span>{text}</span>
    {actionLabel && onAction ? (
      <Button type='button' variant='primary' onClick={onAction}>
        {actionIcon ? <i className={`bi ${actionIcon} me-1`} aria-hidden='true' /> : null}
        {actionLabel}
      </Button>
    ) : null}
  </div>
)
